export default "/img/CY.f165d74a3a4a798769d3801865b3fd36.png";